'use server'

import { apiRequest, ApiResponse } from '../request'

export interface HrVacation {
    id: number
    employeeId: number
    employee?: { id: number; name: string; department: string | null; admissionDate: string | null }
    acquisitivePeriodStart: string
    acquisitivePeriodEnd: string
    daysEntitled: number
    startDate: string | null
    endDate: string | null
    daysUsed: number | null
    pecuniaryAbatement: boolean
    pecuniaryDays: number | null
    status: string
    createdAt: string
}

export interface ExpiringVacation {
    employeeId: number
    employeeName: string
    department: string | null
    acquisitivePeriodStart: string
    acquisitivePeriodEnd: string
    concessiveEnd: string
}

const BASE = 'hr/vacations'

export async function getVacations(params?: { employeeId?: number; status?: string }): Promise<ApiResponse<HrVacation[]>> {
    return apiRequest<HrVacation[]>(BASE, { params: params || {} })
}

export async function getVacation(id: number): Promise<ApiResponse<HrVacation>> {
    return apiRequest<HrVacation>(`${BASE}/${id}`, {})
}

export async function getExpiringVacations(): Promise<ApiResponse<ExpiringVacation[]>> {
    return apiRequest<ExpiringVacation[]>(`${BASE}/expiring`, {})
}

export async function createVacation(data: any): Promise<ApiResponse<HrVacation>> {
    return apiRequest<HrVacation>(BASE, { data }, 'post')
}

export async function updateVacation(id: number, data: any): Promise<ApiResponse<HrVacation>> {
    return apiRequest<HrVacation>(`${BASE}/${id}`, { data }, 'patch')
}

export async function deleteVacation(id: number): Promise<ApiResponse<void>> {
    return apiRequest<void>(`${BASE}/${id}`, {}, 'delete')
}
